import React from "react";
import { isLogged, modalPaths } from "../../ScrollReader/helpers";

import FormContainer from "../../design/onboarding/FormContainer";
import ToggleSignInSignUp from "../../design/onboarding/ToggleSignInSignUp";

import LoginForm from "./LoginForm.js";
import SocialLogins from "../SocialLogins.js";
import RedirectWhen from "../../utils/RedirectWhen.js";
import Modal from "../../Modal.js";

export const LOGIN_MODAL_SIZE = {
  width: "368px",
  height: "635px"
};

class LoginModal extends React.Component {
  componentDidMount() {
    // INFO: POP-fixes-pt1: app/assets/javascripts/landing/scripts/discover.js
    // zapobieganie wyświetleniu modala z akcją na story show
    Cookie.erase('popcomics-discover-back-path');
    Cookie.erase('popcomics-discover-rate');
    Cookie.erase('popcomics-discover-report');
  }

  render() {
    const { location: { search }, blockModal, success} = this.props;
    const animate = search === "" ? "start" : "stay";
    return (
      <RedirectWhen when={!blockModal && isLogged()} to="">
        <Modal {...LOGIN_MODAL_SIZE} current={animate} success={success}>
          <FormContainer title={I18n.t("components.signInModal.title")}>
            <LoginForm />
            <SocialLogins />
            <ToggleSignInSignUp
              text={I18n.t("components.signInModal.noAccount")}
              buttonText={I18n.t("components.signInModal.signUp")}
              hashPath={`${modalPaths.signUp}?m`}
            />
          </FormContainer>
        </Modal>
      </RedirectWhen>
    );
  }
}

export default LoginModal;
